"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constructFormState = exports.mapFalsyParamsToNull = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _enums = require("MeetingsLib/constants/enums");

var mapFalsyParamsToNull = function mapFalsyParamsToNull(_ref) {
  var params = _ref.params;
  return Object.keys(params).reduce(function (acc, key) {
    return Object.assign({}, acc, (0, _defineProperty2.default)({}, key, params[key] || null));
  }, {});
};

exports.mapFalsyParamsToNull = mapFalsyParamsToNull;

var constructFormState = function constructFormState(formFieldUrlParams) {
  var firstName;
  var lastName;
  var email;
  var paramsAsMap = (0, _immutable.Map)(formFieldUrlParams);
  var customFormFields = paramsAsMap.reduce(function (acc, val, originalKey) {
    var key = originalKey.toLowerCase();

    if (key === 'firstname') {
      firstName = val;
    } else if (key === 'lastname') {
      lastName = val;
    } else if (key === 'email') {
      email = val;
    } else if (_enums.EXCLUDED_FORM_FIELDS.indexOf(key) === -1) {
      acc[originalKey] = val;
    }

    return acc;
  }, {});
  return {
    firstName: firstName,
    lastName: lastName,
    email: email,
    customFormFields: customFormFields
  };
};

exports.constructFormState = constructFormState;